import { render, staticRenderFns } from "./StockReductionNew_Items.vue?vue&type=template&id=7519246c&"
import script from "./StockReductionNew_Items.vue?vue&type=script&lang=js&"
export * from "./StockReductionNew_Items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports